import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PatientSummaryComponent} from '@modules/cy/patient/ps/pages/patient-summary/patient-summary.component';
import {physicianGuard} from '@app/auth/guards/physician.guard';
import {EditComponent} from '@modules/cy/patient/ps/create-edit/pages/edit/edit.component';
import {CreateComponent} from '@modules/cy/patient/ps/create-edit/pages/create/create.component';
import {ViewComponent} from '@modules/cy/patient/ps/create-edit/pages/view/view.component';

export const CreateEditRoutes: Routes = [
  {
    path: '',
    component: ViewComponent,
    canActivate: [physicianGuard]
  },
  {
    path: 'edit',
    component: EditComponent,
    canActivate: [physicianGuard]
  },
  {
    path: 'create',
    component: CreateComponent,
    canActivate: [physicianGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(CreateEditRoutes)],
  exports: [RouterModule]
})
export class CreateEditRoutingModule { }
